<div class="row drawer-content drawer-direct-content">
    <div class="col">
        <div class="drawer-panel mt-4" *ngIf="group">
            <div class="form-group m-0">
                <label class="input-label ml-0">{{"Group name" | translate}}</label>
                <input type="text" class="form-control" [(ngModel)]="group.name">
            </div>
            <div class="form-group mb-0">
                <span class="list-item-field mr-0 ml-0" (click)="group.defaultStatus = !group.defaultStatus;">
                    <i style="position: relative; top: 2px;" class="fa-toggle-large-on {{group.defaultStatus ? '' : 'fa-flip-horizontal toggle__icon'}} fas mr-2 toggle-primary"></i>
                    {{ "Is open by default" | translate}}
                </span>
            </div>
        </div>
        <div class="drawer-panel mt-4" *ngIf="group?.services">
            <div class="form-group mb-0">
                <label class="input-label ml-0">{{"Group contains" | translate}}</label>
                <ul>
                    <li *ngFor="let service of group.services">{{service.name}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>